import {
  NotificationBannerAction,
  CartOpenAction
} from '../reducers/otherReducers'

export const openCart = (): CartOpenAction => ({
  type: 'OPEN_CART'
})

export const closeCart = (): CartOpenAction => ({
  type: 'CLOSE_CART'
})

export const showBanner = (
  payload: NotificationBannerAction['payload']
): NotificationBannerAction => ({
  type: 'HIDE_SHOW_NOTIFICATION_BANNER',
  payload
})
